import { render, staticRenderFns } from "./CurriculumPage.vue?vue&type=template&id=78c0e620"
import script from "./CurriculumPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurriculumPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports